module.exports = __webpack_public_path__ + "img/banner3.6366a34f.png";